var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuCollapsedAcion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 16H0V13.3333H13V16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.33337H0V6.66669H16V9.33337Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.66669V0H13V2.66669H0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4534 2.88L20.2267 7.66663L15.4534 12.4533L17.3334 14.3333L24 7.66663L17.3334 1L15.4534 2.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuCollapsedAcion);
export default __webpack_public_path__ + "static/media/IconMenuCollapsedAcion.3871d9be6c79d11610331d662c2109f9.svg";
export { ForwardRef as ReactComponent };